"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductDuration = exports.EAppType = exports.EEntitlementType = exports.EProductType = void 0;
/**
 * TODO:: Refactor so that it only has product and not entitlements
 */
var EProductType;
(function (EProductType) {
    EProductType[EProductType["ALL"] = 0] = "ALL";
    EProductType[EProductType["QBANK"] = 1] = "QBANK";
    EProductType[EProductType["OSCE"] = 2] = "OSCE";
    EProductType[EProductType["BUNDLE"] = 3] = "BUNDLE";
    EProductType[EProductType["ANATOMY"] = 4] = "ANATOMY";
    EProductType[EProductType["MEDICAL_SCIENCES"] = 5] = "MEDICAL_SCIENCES";
    EProductType[EProductType["ANATOMY_BUNDLE"] = 6] = "ANATOMY_BUNDLE";
    EProductType[EProductType["MRCP_PART1"] = 7] = "MRCP_PART1";
    EProductType[EProductType["MRCP_PART2"] = 8] = "MRCP_PART2";
    EProductType[EProductType["PACES"] = 9] = "PACES";
    EProductType[EProductType["MSRA"] = 10] = "MSRA";
    EProductType[EProductType["INTERVIEW_ANAESTHETICS"] = 11] = "INTERVIEW_ANAESTHETICS";
    EProductType[EProductType["INTERVIEW_CST"] = 12] = "INTERVIEW_CST";
    EProductType[EProductType["INTERVIEW_IMT"] = 13] = "INTERVIEW_IMT";
    EProductType[EProductType["INTERVIEW_RADIOLOGY"] = 14] = "INTERVIEW_RADIOLOGY";
    EProductType[EProductType["INTERVIEW_PAEDIATRICS"] = 45] = "INTERVIEW_PAEDIATRICS";
    EProductType[EProductType["CLINICAL"] = 15] = "CLINICAL";
    EProductType[EProductType["DATA_INTERPRETATION"] = 16] = "DATA_INTERPRETATION";
    EProductType[EProductType["CLINICAL_SUBSET"] = 17] = "CLINICAL_SUBSET";
    EProductType[EProductType["CLINICAL_PROBLEM_SOLVING"] = 18] = "CLINICAL_PROBLEM_SOLVING";
    EProductType[EProductType["PROFESSIONAL_DILEMMA"] = 19] = "PROFESSIONAL_DILEMMA";
    EProductType[EProductType["HISTORY_TAKING"] = 20] = "HISTORY_TAKING";
    EProductType[EProductType["COMMUNICATION_SKILLS"] = 21] = "COMMUNICATION_SKILLS";
    EProductType[EProductType["EXAMINATION"] = 22] = "EXAMINATION";
    EProductType[EProductType["PROCEDURE"] = 23] = "PROCEDURE";
    EProductType[EProductType["INTERPRETATION"] = 24] = "INTERPRETATION";
    EProductType[EProductType["ABCDE"] = 25] = "ABCDE";
    EProductType[EProductType["PRESCRIBING"] = 26] = "PRESCRIBING";
    EProductType[EProductType["MIXED"] = 27] = "MIXED";
    EProductType[EProductType["ABDOMINAL"] = 28] = "ABDOMINAL";
    EProductType[EProductType["CARDIOVASCULAR"] = 29] = "CARDIOVASCULAR";
    EProductType[EProductType["COMMUNICATION"] = 30] = "COMMUNICATION";
    EProductType[EProductType["CONSULTATION"] = 31] = "CONSULTATION";
    EProductType[EProductType["NEUROLOGY"] = 32] = "NEUROLOGY";
    EProductType[EProductType["RESPIRATORY"] = 33] = "RESPIRATORY";
    EProductType[EProductType["PLAB1"] = 34] = "PLAB1";
    EProductType[EProductType["PLAB2"] = 35] = "PLAB2";
    EProductType[EProductType["UCAT"] = 48] = "UCAT";
    EProductType[EProductType["VERBAL_REASONING"] = 49] = "VERBAL_REASONING";
    EProductType[EProductType["DECISION_MAKING"] = 50] = "DECISION_MAKING";
    EProductType[EProductType["QUANTITATIVE_REASONING"] = 51] = "QUANTITATIVE_REASONING";
    EProductType[EProductType["SITUATIONAL_JUDGEMENT"] = 52] = "SITUATIONAL_JUDGEMENT";
    EProductType[EProductType["MRCP_VIDEO"] = 53] = "MRCP_VIDEO";
})(EProductType = exports.EProductType || (exports.EProductType = {}));
var EEntitlementType;
(function (EEntitlementType) {
    EEntitlementType[EEntitlementType["ALL"] = 0] = "ALL";
    EEntitlementType[EEntitlementType["CLINICAL"] = 15] = "CLINICAL";
    EEntitlementType[EEntitlementType["DATA_INTERPRETATION"] = 16] = "DATA_INTERPRETATION";
    EEntitlementType[EEntitlementType["CLINICAL_SUBSET"] = 17] = "CLINICAL_SUBSET";
    EEntitlementType[EEntitlementType["CLINICAL_PROBLEM_SOLVING"] = 18] = "CLINICAL_PROBLEM_SOLVING";
    EEntitlementType[EEntitlementType["PROFESSIONAL_DILEMMA"] = 19] = "PROFESSIONAL_DILEMMA";
    EEntitlementType[EEntitlementType["EXTENDED_MATCHING_QUESTIONS"] = 47] = "EXTENDED_MATCHING_QUESTIONS";
    EEntitlementType[EEntitlementType["HISTORY_TAKING"] = 20] = "HISTORY_TAKING";
    EEntitlementType[EEntitlementType["COMMUNICATION_SKILLS"] = 21] = "COMMUNICATION_SKILLS";
    EEntitlementType[EEntitlementType["EXAMINATION"] = 22] = "EXAMINATION";
    EEntitlementType[EEntitlementType["PROCEDURE"] = 23] = "PROCEDURE";
    EEntitlementType[EEntitlementType["INTERPRETATION"] = 24] = "INTERPRETATION";
    EEntitlementType[EEntitlementType["ABCDE"] = 25] = "ABCDE";
    EEntitlementType[EEntitlementType["PRESCRIBING"] = 26] = "PRESCRIBING";
    EEntitlementType[EEntitlementType["MIXED"] = 27] = "MIXED";
    EEntitlementType[EEntitlementType["ABDOMINAL"] = 28] = "ABDOMINAL";
    EEntitlementType[EEntitlementType["CARDIOVASCULAR"] = 29] = "CARDIOVASCULAR";
    EEntitlementType[EEntitlementType["COMMUNICATION"] = 30] = "COMMUNICATION";
    EEntitlementType[EEntitlementType["CONSULTATION"] = 31] = "CONSULTATION";
    EEntitlementType[EEntitlementType["NEUROLOGY"] = 32] = "NEUROLOGY";
    EEntitlementType[EEntitlementType["RESPIRATORY"] = 33] = "RESPIRATORY";
    EEntitlementType[EEntitlementType["ANATOMY"] = 36] = "ANATOMY";
    EEntitlementType[EEntitlementType["PRE_CLINICAL"] = 37] = "PRE_CLINICAL";
    EEntitlementType[EEntitlementType["MRCP_PART_1"] = 38] = "MRCP_PART_1";
    EEntitlementType[EEntitlementType["MRCP_PART_2"] = 39] = "MRCP_PART_2";
    EEntitlementType[EEntitlementType["INTERVIEW_ANAESTHETICS"] = 40] = "INTERVIEW_ANAESTHETICS";
    EEntitlementType[EEntitlementType["INTERVIEW_CST"] = 41] = "INTERVIEW_CST";
    EEntitlementType[EEntitlementType["INTERVIEW_IMT"] = 42] = "INTERVIEW_IMT";
    EEntitlementType[EEntitlementType["INTERVIEW_RADIOLOGY"] = 43] = "INTERVIEW_RADIOLOGY";
    EEntitlementType[EEntitlementType["INTERVIEW_PAEDIATRICS"] = 46] = "INTERVIEW_PAEDIATRICS";
    EEntitlementType[EEntitlementType["PLAB_1"] = 44] = "PLAB_1";
    EEntitlementType[EEntitlementType["VERBAL_REASONING"] = 49] = "VERBAL_REASONING";
    EEntitlementType[EEntitlementType["DECISION_MAKING"] = 50] = "DECISION_MAKING";
    EEntitlementType[EEntitlementType["QUANTITATIVE_REASONING"] = 51] = "QUANTITATIVE_REASONING";
    EEntitlementType[EEntitlementType["SITUATIONAL_JUDGEMENT"] = 52] = "SITUATIONAL_JUDGEMENT";
    EEntitlementType[EEntitlementType["MRCP_VIDEO"] = 53] = "MRCP_VIDEO";
})(EEntitlementType = exports.EEntitlementType || (exports.EEntitlementType = {}));
var EAppType;
(function (EAppType) {
    EAppType[EAppType["AMS"] = 1] = "AMS";
    EAppType[EAppType["CM_UKMLA"] = 2] = "CM_UKMLA";
    EAppType[EAppType["MRCP"] = 3] = "MRCP";
    EAppType[EAppType["INTERVIEW"] = 4] = "INTERVIEW";
    EAppType[EAppType["MSRA"] = 5] = "MSRA";
    EAppType[EAppType["PLAB"] = 6] = "PLAB";
    EAppType[EAppType["UCAT"] = 7] = "UCAT";
})(EAppType = exports.EAppType || (exports.EAppType = {}));
var EProductDuration;
(function (EProductDuration) {
    EProductDuration[EProductDuration["ALL"] = 0] = "ALL";
    EProductDuration[EProductDuration["ONE"] = 1] = "ONE";
    EProductDuration[EProductDuration["TWO"] = 2] = "TWO";
    EProductDuration[EProductDuration["THREE"] = 3] = "THREE";
    EProductDuration[EProductDuration["SIX"] = 6] = "SIX";
    EProductDuration[EProductDuration["TWELVE"] = 12] = "TWELVE";
})(EProductDuration = exports.EProductDuration || (exports.EProductDuration = {}));
